import type { Registry as Services } from '@ember/service';

export interface AccessFlags {
  features: string[];
  hasParity: boolean;
  hasParityAnalyticsStaff: boolean;
  hasRanking: boolean;
  hasRates: boolean;
  hasThemeAccess: boolean;
}

function collectFeaturesAcrossSubscriptions(
  navigation: Services['navigation'],
): string[] {
  const features = new Set<string>();

  for (const subscriptionFeatures of navigation.subscriptionToFeatures.values()) {
    for (const feature of subscriptionFeatures) {
      features.add(feature);
    }
  }

  return Array.from(features);
}

export default function createAccessFlags(
  access: Services['access'],
  navigation: Services['navigation'],
  theme: Services['theme'],
): AccessFlags {
  // Theme permissions come from the user, so they ignore the unified hotel
  // view widening below.
  const hasThemeAccess = Boolean(theme.hasPermissions);

  if (!navigation.hasUnifiedHotelView) {
    return {
      features: Array.from(access.featureFlags),
      hasParity: access.hasParity,
      hasParityAnalyticsStaff: access.hasParityAnalyticsStaff,
      hasRanking: access.hasRanking,
      hasRates: access.hasRates,
      hasThemeAccess,
    };
  }

  const features = collectFeaturesAcrossSubscriptions(navigation);

  // Mirrors TabService: under unified hotel view rates, parity and ranking
  // answer from every subscription and drop the per-subscription OTA check.
  // Staff parity analytics keeps answering from the current subscription.
  return {
    features,
    hasParity: features.includes('app.parity'),
    hasParityAnalyticsStaff: access.hasParityAnalyticsStaff,
    hasRanking: features.includes('app.ranking'),
    hasRates: features.includes('app.rates'),
    hasThemeAccess,
  };
}
